import { render, staticRenderFns } from "./accumulateDetail.vue?vue&type=template&id=db7eb2ce&scoped=true&"
import script from "./accumulateDetail.vue?vue&type=script&lang=js&"
export * from "./accumulateDetail.vue?vue&type=script&lang=js&"
import style0 from "./accumulateDetail.vue?vue&type=style&index=0&id=db7eb2ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db7eb2ce",
  null
  
)

export default component.exports